/** Operating system types for screenshot key detection */
export type OperatingSystem = 'windows' | 'macos' | 'linux' | 'unknown';

/**
 * Detects the current operating system based on user agent and platform
 */
export function detectOS(): OperatingSystem {
    const userAgent = navigator.userAgent.toLowerCase();
    const platform = navigator.platform?.toLowerCase() ?? '';

    if (platform.includes('mac') || userAgent.includes('macintosh')) {
        return 'macos';
    }

    if (platform.includes('win') || userAgent.includes('windows')) {
        return 'windows';
    }

    if (platform.includes('linux') || userAgent.includes('linux')) {
        return 'linux';
    }

    return 'unknown';
}

/**
 * Detects if the current device is a mobile/touch device
 */
export function isMobileDevice(): boolean {
    // Check for touch capability
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    // Check user agent for mobile indicators
    const userAgent = navigator.userAgent.toLowerCase();
    const mobileKeywords = [
        'android',
        'webos',
        'iphone',
        'ipad',
        'ipod',
        'blackberry',
        'windows phone',
        'opera mini',
        'mobile'
    ];
    const isMobileUA = mobileKeywords.some((keyword) => userAgent.includes(keyword));

    // Check screen size (mobile devices typically < 768px width)
    const isSmallScreen = window.innerWidth < 768;

    // Consider it mobile if it has touch AND (mobile UA or small screen)
    return hasTouch && (isMobileUA || isSmallScreen);
}
